module.exports = __webpack_public_path__ + "img/is-member.efe1be1b.png";